import { render, staticRenderFns } from "./crm-club-meta-data.vue?vue&type=template&id=01f7ffbd&scoped=true&"
import script from "./crm-club-meta-data.vue?vue&type=script&lang=js&"
export * from "./crm-club-meta-data.vue?vue&type=script&lang=js&"
import style0 from "./crm-club-meta-data.vue?vue&type=style&index=0&id=01f7ffbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7ffbd",
  null
  
)

export default component.exports